import {RADIO_BUTTON_NOT_SELECTED, RADIO_BUTTON_SELECTED, RadioButton} from "./RadioButton";
import React, {Component} from "react";

export class RadioButtonOption extends Component {
    render() {
        const { isSelected, onClick, label, note, children } = this.props;

        return <div className="row radio-button-row mb-3 mt-4"
                     onClick={(event) => {event.stopPropagation();onClick();}}>
                    <div className="col-auto pe-0">
                        <RadioButton status={isSelected ? RADIO_BUTTON_SELECTED : RADIO_BUTTON_NOT_SELECTED} />
                    </div>
                    <div className="col pt-2 ps-2">
                        {label}
                        {note && <p className="note">{note}</p>}
                        {isSelected && children}
                    </div>
                </div>;
    }
}